import * as _ from "lodash";

import AdminSettings from "src/pages/Admin/Settings";
import { IRoute } from "src/pages/Router/routes";

import ShutdownsPage from "./ShutdownsPage";
import CreateEditShutdownPage from "./CreateEditShutdownPage";
import OpenDaysPage from "./OpenDaysPage";
import CreateEditOpenDayPage from "./CreateEditOpenDayPage";
import AllBranchesShutdownsPage from "./CustomersHolidaysPage";

const ShutdownRoutes: IRoute[] = [
  {
    exact: true,
    path: "/platform/shutdowns",
    title: "Shutdowns",
    pageComponent: ShutdownsPage,
    parent: AdminSettings[ 0 ],
    menuType: "ADMIN_SHUTDOWN_SETTINGS",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: []
  },
  {
    exact: true,
    path: "/platform/open-days",
    title: "Open Days",
    pageComponent: OpenDaysPage,
    parent: AdminSettings[ 0 ],
    menuType: "ADMIN_SHUTDOWN_SETTINGS",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [],
    modules: [ "shutdown" ]
  },
  {
    exact: true,
    path: "/platform/customers-holidays",
    title: "Customer Holidays",
    parent: AdminSettings[ 0 ],
    pageComponent: AllBranchesShutdownsPage,
    menuType: "ADMIN_SHUTDOWN_SETTINGS",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [],
    modules: [ "shutdown" ]
  }
];

const ShutdownEditRoutes: IRoute[] = [
  {
    exact: true,
    path: "/platform/shutdowns/new",
    title: "Save Shutdown",
    pageComponent: CreateEditShutdownPage,
    menuType: "EMPTY",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [ "create-global-settings" ],
    roles: [ "admin" ],
    modules: [ "shutdown" ],
    parent: _.find(ShutdownRoutes, route => route.title === "Shutdowns")
  },
  {
    exact: true,
    path: "/platform/shutdowns/edit/:shutdownId",
    title: "Save Shutdown",
    pageComponent: CreateEditShutdownPage,
    menuType: "EMPTY",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [ "amend-global-settings" ],
    roles: [ "admin" ],
    modules: [ "shutdown" ],
    parent: _.find(ShutdownRoutes, route => route.title === "Shutdowns")
  }
];

const OpenDaysEditRoutes: IRoute[] = [
  {
    exact: true,
    path: "/platform/open-days/new",
    title: "Save Open Day",
    pageComponent: CreateEditOpenDayPage,
    menuType: "EMPTY",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [ "create-global-settings" ],
    roles: [ "admin" ],
    modules: [ "shutdown" ],
    parent: _.find(ShutdownRoutes, route => route.title === "Open Days")
  },
  {
    exact: true,
    path: "/platform/open-days/edit/:openDayId",
    title: "Save Open Day",
    pageComponent: CreateEditOpenDayPage,
    menuType: "EMPTY",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [ "amend-global-settings" ],
    roles: [ "admin" ],
    modules: [ "shutdown" ],
    parent: _.find(ShutdownRoutes, route => route.title === "Open Days")
  }
];

const CustomerHolidaysEditRoutes: IRoute[] = [
  {
    exact: true,
    path: "/platform/shutdowns/edit/:shutdownId",
    title: "Save Shutdown",
    pageComponent: CreateEditShutdownPage,
    menuType: "EMPTY",
    context: "PLATFORM_SETTINGS",
    privateRoute: true,
    permissions: [ "amend-global-settings" ],
    roles: [ "admin" ],
    modules: [ "shutdown" ],
    parent: _.find(ShutdownRoutes, route => route.title === "Customer Holidays")
  }
];

export default [
  ...ShutdownRoutes,
  ...ShutdownEditRoutes,
  ...OpenDaysEditRoutes,
  ...CustomerHolidaysEditRoutes
];
